import { render } from "./ImageUpload-Github.vue?vue&type=template&id=a879cae8&scoped=true"
import script from "./ImageUpload-Github.vue?vue&type=script&lang=js"
export * from "./ImageUpload-Github.vue?vue&type=script&lang=js"

import "./ImageUpload-Github.vue?vue&type=style&index=0&id=a879cae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a879cae8"]])

export default __exports__